'use client';

import { RefObject, useCallback, useRef, useState } from 'react';
import useEscapeKeydown from '@/hooks/useEsacapeKeydown';
import { UserIcon } from '@/assets/icons/UserIcon';
import { DownloadButtonProps } from '@/ui-components/molecules/AppDownloadButtons/AppDownloadButtons';
import { SnapshotUserPopover } from './SnapshotUserPopover';
import styles from './snapshotpopover.module.scss';

interface AnonymousUserSnapshotIconProps {
    appdownloadItem?: DownloadButtonProps[];
}

export function AnonymousUserSnapshotIcon({
    appdownloadItem,
}: AnonymousUserSnapshotIconProps): React.JSX.Element {
    const [open, setOpen] = useState(false);
    const buttonRef = useRef<HTMLButtonElement>(null);

    const handleClose = useCallback(() => {
        setOpen(false);
    }, []);

    useEscapeKeydown(handleClose);

    return (
        <div className={styles.snapshotTrigger}>
            <button
                ref={buttonRef}
                aria-expanded={open}
                aria-haspopup="dialog"
                aria-label="user account"
                className={styles.snapshotIconButton}
                onClick={() => setOpen((previousOpen) => !previousOpen)}
                type="button"
            >
                <UserIcon />
            </button>

            <SnapshotUserPopover
                appdownloadItem={appdownloadItem}
                buttonRef={buttonRef as RefObject<HTMLButtonElement | null>}
                onClose={handleClose}
                open={open}
            />
        </div>
    );
}
